<div [id]="id" class="google-map"></div>
<div class="button-group" *ngIf="!hideControls">
  <button (click)="startDrawing()" [class.active]="activeMode === 'draw'" class="custom-btn">Draw Polygon</button>
  <button (click)="enableSelectMode()" [class.active]="activeMode === 'select'" class="custom-btn-select">
    Select Polygon
  </button>
</div>
<div class="map-legend-container" *ngIf="!hideLegend">
  <div class="map-legend">
    <span class="legend-marker marker-type-subject"></span>
    <span>Subject</span>
  </div>
  <div class="map-legend">
    <span class="legend-marker marker-type-foreclosure"></span>
    <span>Foreclosure</span>
  </div>
  <div class="map-legend">
    <span class="legend-marker marker-type-active"></span>
    <span>Active</span>
  </div>
  <div class="map-legend">
    <span class="legend-marker marker-type-pending"></span>
    <span>Pending</span>
  </div>
  <div class="map-legend">
    <span class="legend-marker marker-type-sold"></span>
    <span>Sold</span>
  </div>
  <div class="map-legend">
    <span class="legend-marker marker-type-disabled"></span>
    <span>Disabled</span>
  </div>
</div>

<!-- <div class="d-flex mt-4 float-right" *ngIf="!hideControls">
  <button mat-stroked-button class="me-3" color="danger" (click)="deleteOverlay('selected')">
    <mat-icon>delete</mat-icon>
    Delete Selected
  </button>
  <button mat-flat-button class="me-3" color="primary" (click)="deleteOverlay('all')">
    <mat-icon>backspace</mat-icon>
    Clear All
  </button> -->
<!-- <button mat-stroked-button class="me-3" color="primary" (click)="resetOverlay()">
    <mat-icon>replay</mat-icon>
    Reset
  </button> -->
<!-- <div class="ms-auto">
    <button mat-button color="primary" (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="accent" (click)="onSubmit()">
      <span>Save & Continue</span>
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div> -->

<div class="d-flex mt-4 align-items-center justify-content-between" *ngIf="!hideControls">
  <!-- LEFT SIDE BUTTONS -->
  <div class="d-flex align-items-center">
    <button mat-stroked-button class="me-3 close-sheet-icon" color="primary" (click)="resetOverlay()">
      <mat-icon>replay</mat-icon>
    </button>

    <button
      mat-stroked-button
      class="ml-2 close-sheet-icon d-block d-md-none"
      color="danger"
      (click)="deleteOverlay('selected')"
    >
      <mat-icon>delete</mat-icon>
    </button>
    <button mat-stroked-button class="ml-2 d-none d-md-block" color="danger" (click)="deleteOverlay('selected')">
      <mat-icon>delete</mat-icon>
      Delete Selected Polygon
    </button>
  </div>

  <!-- RIGHT SIDE BUTTONS -->
  <div class="d-flex align-items-center">
    <button mat-button class="mr-2" color="primary" (click)="onCancel()">Cancel</button>

    <button mat-flat-button color="primary" (click)="onSubmit()">
      <span>Save & Continue</span>
    </button>
  </div>
</div>
